export default "__VITE_ASSET__B7Gp1$OG__"